<div
  *ngIf="job"
  class="compact-job-list-item">
  <div
    *ngFor="let column of columns$ | async; trackBy: trackByColumnKey"
    class="compact-job-list-item-column"
    [attr.data-column-key]="column.key"
    [class.with-text-m]="true"
    [class.with-text-ellipsis]="true"
    [class.with-small-spacing]="column.smallSpacing"
    [class.with-fade-right]="column.key === 'shift'">
    <div *ngIf="column.key === 'shift'">
      <app-job-list-item-date-time [job]="job"></app-job-list-item-date-time>
    </div>

    <div *ngIf="column.key === 'department'">
      <app-job-list-item-organisation-heading
        [jobType]="job.multiDayId ? 'job-series' : 'job'"
        [department]="job.department"
        [organisation]="job.organisation"
        [departmentOnly]="true"
        [compact]="true"></app-job-list-item-organisation-heading>
    </div>

    <span
      *ngIf="column.key === 'organisation'"
      [attr.title]="job.organisation?.name">
      {{ job.organisation?.name }}
    </span>

    <div *ngIf="column.key === 'address'">
      <span
        title="{{
          job.organisation.address?.street +
            ', ' +
            job.organisation.address?.zip +
            ' ' +
            job.organisation.address?.location
        }}">
        {{
          job.organisation.address?.street
            ? job.organisation.address?.street + ", "
            : ""
        }}
        {{
          job.organisation.address?.zip
            ? job.organisation.address?.zip + " "
            : ""
        }}
        {{
          job.organisation.address?.location
            ? job.organisation.address?.location
            : ""
        }}
      </span>
      <span [attr.title]="job.department.phone || ''">
        {{
          !job.department.phone
            ? ""
            : job.organisation.address
            ? " | " + job.department.phone
            : job.department.phone
        }}
      </span>
    </div>

    <span
      *ngIf="column.key === 'jobType'"
      [attr.title]="('jobTypeEnum.' + (job?.jobType || '') | i18n) || ''">
      {{ ("jobTypeEnum." + (job?.jobType || "") | i18n) || "" }}
    </span>

    <span
      *ngIf="column.key === 'description'"
      [attr.title]="job.description">
      {{ job.description }}
    </span>

    <span
      *ngIf="column.key === 'certificate'"
      [attr.title]="jobCertificates$ | async">
      {{ jobCertificates$ | async }}
    </span>

    <span
      *ngIf="column.key === 'offerFrom'"
      [attr.title]="job?.yourself?.customer?.displayName">
      {{ job?.yourself?.customer?.displayName }}
    </span>
  </div>
</div>
